<template>
  <div
    class="label-description-field label-description-field--glass"
    :class="[
      {
        'label-description-field--flex': flex,
        'label-description-field--error': hasError,
      },
      customClass,
    ]"
  >
    <span :id="labelId" class="label-description-field__label">
      {{ label }}<span v-if="required" class="label-description-field__required" aria-hidden="true">*</span>
    </span>
    <div class="label-description-field__control">
      <textarea
        :id="inputId"
        :value="modelValue"
        class="label-description-field__textarea"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :readonly="readOnly"
        :rows="rows"
        :aria-labelledby="labelId"
        :aria-invalid="hasError ? 'true' : 'false'"
        @input="onInput"
        @blur="$emit('blur', $event)"
      />
    </div>
    <div v-if="$slots.default" class="label-description-field__messages">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelDescriptionField',
  props: {
    label: {
      type: String,
      default: 'Notes',
    },
    inputId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: [Number, String],
      default: 2,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'input', 'blur'],
  computed: {
    labelId() {
      return `${this.inputId}-label`;
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
  },
};
</script>

<style src="../styles/LabelDescriptionField.css"></style>
